module.exports = __webpack_public_path__ + "static/media/memberbannerfr.70bc4464.png";